if (!customElements.get('section-lta-hero-banner')) {
	customElements.define(
		'section-lta-hero-banner',
		class SectionLtaHeroBanner extends HTMLElement {
			constructor() {
				super();

				this.sectionId = this.dataset.id;

				this.setupCarousel();
			}

			setupCarousel() {
				if (!window.Swiper || !this.sectionId) return;

				this.sectionSwiper = new window.Swiper(`#Carousel-${this.sectionId}`, {
					loop: true,
					grabCursor: false,
					autoHeight: true,
					lazy: true,
					resistanceRatio: 0.7,
					speed: 300,
					threshold: 10,
					slidesPerView: 1,
					pagination: {
						el: `#CarouselPagination-${this.sectionId}`,
						clickable: true,
					},
				});
			}
		}
	);
}

